import { FC, useRef } from 'react';
import { Button, Flex, Progress, Text } from '@gravity-ui/uikit';
import { MobileVideoInfoForm } from './MobileVideoInfoForm';
import { DragAndDrop } from '../../VideoUpload/components/DragAndDrop';
import { ProfilesRecord } from '../../Page/types/ProfilesRecord';
import { UploadState } from '../hooks/useMobileUpload';
import { commonT, videoUploadT } from '../../../i18n';

type MobileUploadViewProps = {
    uploadState: UploadState;
    profiles: ProfilesRecord;
    onFileSelected: (files: File[]) => void;
    onChangeName: (value: string) => void;
    onChangeProfile: (value: string) => void;
    onToggleSummarization: () => void;
};

export const MobileUploadView: FC<MobileUploadViewProps> = ({
    uploadState,
    profiles,
    onFileSelected,
    onChangeName,
    onChangeProfile,
    onToggleSummarization,
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <div className="mobile-upload-view">
            {uploadState.file ? (
                /* Файл выбран — показываем форму */
                <>
                    <Text
                        variant="body-2"
                        color="secondary"
                        className="mobile-upload-view__filename"
                    >
                        {uploadState.file.name}
                    </Text>
                    <MobileVideoInfoForm
                        profile={uploadState.profile}
                        profiles={profiles}
                        name={uploadState.videoTitle}
                        enableSummarization={uploadState.enableSummarization}
                        placeholder={uploadState.file.name}
                        onChangeName={onChangeName}
                        onChangeProfile={onChangeProfile}
                        onToggleSummarization={onToggleSummarization}
                        disabled={uploadState.isUploading}
                    />
                    {uploadState.isUploading && (
                        <Progress
                            theme="success"
                            value={uploadState.progress}
                            text={videoUploadT('uploadProgress', {
                                progress: uploadState.progress,
                            })}
                        />
                    )}
                </>
            ) : (
                /* Файл не выбран — кнопка по центру */
                <Flex
                    className="mobile-upload-view__choose-area"
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Button view="action" size="xl" onClick={() => inputRef.current?.click()}>
                        {commonT('chooseFile')}
                    </Button>
                </Flex>
            )}

            <DragAndDrop onSuccess={onFileSelected} inputRef={inputRef} multiple={false} />
        </div>
    );
};
